import request from '@/utils/request'
// import queryString from 'querystring'
export function fetchCompanies(data) {
    return request({
        url: '/users/realAuth/company/search',
        method: 'get',
        params: data
    })
}

// 查询企业是否已认证
export function queryCompanyIsAuth(data) {
    return request({
        url: '/users/realAuth/company/isAuth/query',
        method: 'get',
        params: data,
    })
}
//获取实人认证信息
export function fetchInfo(data) {
    return request({
        url: '/users/realAuth/info',
        method: 'post',
        data: data
    })
}
